// Canonical player color families shared across frontend/backend/validation.
export const PLAYER_COLOR_FAMILIES = [
    'red',
    'orange',
    'amber',
    'yellow',
    'lime', // Reserved for Poppy (non-playable for users)
    'green',
    'emerald',
    'teal',
    'cyan',
    'sky',
    'blue',
    'indigo',
    'violet',
    'purple',
    'fuchsia',
    'pink',
    'rose',
];
export const PLAYABLE_PLAYER_COLOR_FAMILIES = PLAYER_COLOR_FAMILIES.filter((family) => family !== 'lime');
/** All families tintable on 3D balloon bodies — includes lime (Poppy). */
export const BALLOON_BODY_COLOR_FAMILIES = PLAYER_COLOR_FAMILIES;
//# sourceMappingURL=playerColors.js.map